<template>
	<div v-if="page.slug === '404'">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :subtitle="page.subtitle" :content="page.content" />
	</div>
	<div v-else>
		<slot />
	</div>
</template>

<script setup>
defineProps({
	page: { type: Object, default: () => {} },
	locale: { type: Object, default: () => {} },
});
</script>
